import React, { useState } from "react";
import { ReactComponent as BackArrow } from "../../assets/navbar/BackArrow.svg";
import { ReactComponent as RecipeImg } from "../../assets/analyse/AnalyseRecipe.svg";
import { ReactComponent as DeliveryIcon } from "../../assets/analyse/DeliveryIcon.svg";
import { ReactComponent as ConsumptionIcon } from "../../assets/analyse/consumption.svg";
import { ReactComponent as RetailIcon } from "../../assets/analyse/retail.svg";
import { ReactComponent as DistributionIcon } from "../../assets/analyse/distribution.svg";
import { ReactComponent as Plus } from "../../assets/analyse/Plus.svg";
import { ReactComponent as Upload } from "../../assets/analyse/upload.svg";
import "react-toastify/dist/ReactToastify.css";
import AnalysisLine from "./AnalysisLine";
import "react-widgets/styles.css";
import AddStep from "./AddStep";
import StepResult from "./StepResult";
import ColabMenu from "./ColabMenu";
// import spinach from "../../app_data/ingredients/ref_ing_spinach.json";
import { isDisabled } from "@testing-library/user-event/dist/utils";
import { columnsNames } from "../../css/columns";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import UploadPanel from "./UploadPanel";

const AnalysisStep = ({ name, hidden, setHidden, icon, size, data, width, columns, ingredients, totalScore, depth, is_substep }) => {
  const hiddenindex = data.step_index + depth * 5;
  const [addMenu, setAddMenu] = useState("");
  const [showUploadPanel, setShowUploadPanel] = useState(false);
  const [collabMenu, setCollabmenu] = useState("");
  const [menupos, setmenupos] = useState({ x: 0, y: 0 });
  const analysis_data = useSelector((state) => state.analysis.analysis_data, shallowEqual); //? state.analysis.analysis_data : null)
  var result = data.outputs[0]; //result.impact + "%";
  const user_info = useSelector((state) => (state.user.user_info ? state.user.user_info : null));

  return (
    <>
      {addMenu ? <AddStep step={data.step_index} setAddMenu={setAddMenu} is_substep={is_substep} /> : null}
      {collabMenu ? <ColabMenu colabMenu={collabMenu} menuPos={menupos} name={name} setColabMenu={setCollabmenu} /> : null}
      <div className={""}>
        <div className={"h-full"}>
          {/* CSSM STEP HEADER */}
          <div className={`h-[40px] bg-white border-[0.1px] boder-[#F3F5F7] flex w-max`}>
            <div style={{ width: width }} className={`items-center flex justify-between`}>
              <button
                className="flex items-center"
                onClick={() => {
                  let newhidden = [...hidden];
                  newhidden[hiddenindex] = !newhidden[hiddenindex];
                  setHidden(newhidden);
                }}
                onContextMenu={(event) => {
                  event.preventDefault();
                  let pos = { x: event.pageX, y: event.pageY };
                  setmenupos(pos);
                  setCollabmenu(1);
                }}
              >
                <BackArrow transform={`rotate(${270 - 90 * (hidden[hiddenindex] ? hidden[hiddenindex] : 0)})`} className="ml-[15px]" height={10} />

                <div className={"w-[40px] justify-center flex"}>
                  {icon === "Recette" ? (
                    <RecipeImg height={20} />
                  ) : icon === "Packaging" ? (
                    <DeliveryIcon height={20} />
                  ) : icon === "Distribution" ? (
                    <DistributionIcon height={20} />
                  ) : icon === "Vente au détail" ? (
                    <RetailIcon height={20} />
                  ) : icon === "Consommation" ? (
                    <ConsumptionIcon height={20} />
                  ) : null}
                </div>
                <p className="font-Poppins-SemiBold">{name}</p>
              </button>
              {user_info.organization_info.role.access.analyse.write && ((data.step_index !== 2) || data.step_index === 3 || (data.step_index === 2 && data.inputs)) && (
                <div>
                  <button
                    onClick={() => {
                      setShowUploadPanel(true);
                    }}
                  >
                    <Upload height={10} />
                  </button>
                  <button
                    onClick={() => {
                      setAddMenu(1);
                    }}
                  >
                    <Plus height={10} />
                  </button>
                </div>
              )}
              {/* {user_info.organization_info.role.access.analyse.write && ((data.step_index !== 2 && data.inputs) || data.step_index === 3 || (data.step_index === 2 && data.inputs)) && (
                <button
                  onClick={() => {
                    setAddMenu(1);
                  }}
                >
                  <Plus height={10} />
                </button>
              )} */}
            </div>
          </div>


          {showUploadPanel ? <UploadPanel setShowUploadPanel={setShowUploadPanel} step_index={data.step_index} /> : null}

          {hidden[hiddenindex] ? null : (
            <>
              {data.step_index !== 2 && data.inputs ? (
                <>
                  <div>
                    {Object.values(data.inputs).map((current, i) => {
                      if (depth === 0 && (current.flow.category.name === "K_Wastes" || current.flow.category.name === "K_Food_Given")) {
                        // console.log(current.flow.category, ":", depth);
                        return;
                      }
                      return (
                        <AnalysisLine
                          
                          item={current.flow.name_fr}
                          quantity={current.amount}
                          quantityUnit={current.unit.name}
                          totalScore={totalScore}
                          // impact={(((current.flow.flow_impact_factors.find((i) => i.name === "Unique Score").coefficient * current.amount * current.unit.conversion_factor) / totalScore) * 100).toFixed(2)}
                          impact_factors={current.flow.flow_impact_factors}
                          checked={current.checked}
                          changable={data.step_index <= 2 ? ingredients : current}
                          // changable={
                          //   current.flow.category.name === "K_Food_Given" || current.flow.category.name === "K_Cooking" || current.flow.category.category_path.includes("Transformation") === true
                          //     ? null
                          //     : data.step_index <= 2
                          //     ? ingredients
                          //     : current
                          // }
                          width={width}
                          columns={columns}
                          step={data.step_index}
                          // line_index={i}
                          line_index={depth === 1 ? Object.values(Object.values(analysis_data.lca.lca_steps)[Math.abs(data.step_index - 6)].outputs).findIndex((x) => x.id === current.id) : i}
                          // flow_id={current.flow.id}
                          flow_id={current.id}
                          icon={current.flow.category.name}
                          conversion_factor={current.unit.conversion_factor}
                          k_type={current.flow.category.name}
                          description={current.description_fr}
                        />
                      );
                    })}

                    {/* {Object.values(data.outputs) && Object.keys(Object.values(data.outputs).filter((x) => x.flow.category.name === "K_Wastes")).length > 0 && depth === 0 ? ( */}
                    {Object.values(data.outputs).filter((x) => x && (x.flow.category.name === "K_Wastes" || x.flow.category.name === "K_Food_Given")).length > 0 && depth === 0 ? (
                      <div className="flex" >
                        <div className="w-[30px]" />
                        <AnalysisStep
                          hidden={hidden}
                          setHidden={setHidden}
                          className="relative ml-[30px] left-[30px]"
                          columns={columns}
                          name={"Déchets et revalorisation"}
                          icon={"Distribution"}
                          is_substep={true}
                          width={width - 30}
                          size={1}
                          ingredients={null}
                          totalScore={totalScore}
                          data={{
                            outputs: [null],
                            step_index: data.step_index,
                            inputs: Object.values(data.outputs) && Object.values(data.outputs).filter((x) => x && (x.flow.category.name === "K_Wastes" || x.flow.category.name === "K_Food_Given")),
                          }}
                          depth={depth + 1}
                        />
                      </div>
                    ) : null}
                  </div>
                </>
              ) : (
                data.step_index === 2 && (
                  <>
                    {Object.values(ingredients).length == 0 ? (
                      <>
                        {Object.values(data.outputs).map((current, i) => (
                          <>
                            <AnalysisLine
                              key={`${current.flow.name_fr}` + `${i}`}
                              item={current.flow.name_fr}
                              quantity={current.amount}
                              quantityUnit={current.unit.name}
                              totalScore={totalScore}
                              // impact={(((current.flow.flow_impact_factors.find((i) => i.name === "Unique Score").coefficient * current.amount * current.unit.conversion_factor) / totalScore) * 100).toFixed(2)}
                              impact_factors={current.flow.flow_impact_factors}
                              checked={current.checked}
                              changable={null}
                              width={width}
                              columns={columns}
                              step={data.step_index}
                              line_index={i}
                              // flow_id={current.flow.id}
                              flow_id={current.id}
                              icon={current.flow.category.name}
                              conversion_factor={current.unit.conversion_factor}
                              k_type={current.flow.category.name}
                              description={current.description_fr}
                            />
                          </>
                        ))}
                      </>
                    ) : (
                      <>
                        {Object.values(data.inputs).map((current, i) => (
                          <>
                            <AnalysisLine
                              key={`${current.flow.name_fr}` + `${i}`}
                              item={current.flow.name_fr}
                              quantity={current.amount}
                              quantityUnit={current.unit.name}
                              totalScore={totalScore}
                              // impact={(((current.flow.flow_impact_factors.find((i) => i.name === "Unique Score").coefficient * current.amount * current.unit.conversion_factor) / totalScore) * 100).toFixed(2)}
                              impact_factors={current.flow.flow_impact_factors}
                              checked={current.checked}
                              // changable={
                              //   current.flow.category.category_path.includes("Dummies") ||
                              //   current.flow.category.name === "K_Food_Given" ||
                              //   current.flow.category.name === "K_Cooking" ||
                              //   current.flow.category.category_path.includes("Transformation") === true
                              //     ? null
                              //     : data.step_index <= 2
                              //     ? ingredients
                              //     : current
                              // }
                              changable={data.step_index <= 2 ? ingredients : current}
                              is_dummy={current.flow.category.category_path.includes("Dummies")}
                              loss={current.flow.loss}
                              raw_to_cooked={current.flow.raw_to_cooked}
                              width={width}
                              columns={columns}
                              step={data.step_index}
                              // line_index={i}
                              line_index={depth === 1 ? Object.values(Object.values(analysis_data.lca.lca_steps)[Math.abs(data.step_index - 6)].outputs).findIndex((x) => x.id === current.id) : i}
                              // flow_id={current.flow.id}
                              flow_id={current.id}
                              icon={current.flow.category.name}
                              conversion_factor={current.unit.conversion_factor}
                              k_type={current.flow.category.name}
                              description={current.description_fr}
                            />
                          </>
                        ))}
                      </>
                    )}
                  </>
                )
              )}
            </>
          )}

          {result == null ? null : <StepResult columns={columns} result={result} totalScore={totalScore} step_index={data.step_index} />}
        </div>
      </div>
    </>
  );
};

export default AnalysisStep;
